import { Spinner } from '@/components/ui/spinner';

export function InitialLoader() {
  return (
    <div className="fixed inset-0 bg-background flex items-center justify-center z-50">
      <div className="flex flex-col items-center gap-6">
        <Spinner size="lg" />

        {/* Barra de loading temática */}
        <div className="w-40 h-1.5 bg-secondary/50 rounded-full overflow-hidden">
          <div className="h-full rounded-full
                          bg-gradient-to-r from-orange-500 via-primary to-orange-500
                          animate-forge-heat" />
        </div>

        <p className="text-xs text-muted-foreground/50 animate-pulse">
          Preparando sua forja...
        </p>
      </div>
    </div>
  );
}
